<template>
	<select @change='change' v-model="selected" class='form-control my-control' :class='field_class'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ORGANIZATION = 'get_organization.php'
	const HEADER = 'get_header.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'organization',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			field_class: '',
			id: null
		},
		methods: {
			change () {
				EventBus.$emit(`edit_organization`, this.selected)
			}
		},
		created () {
			let id = this.$route.params.id || this.$props.id
			fetch(DB + HEADER + `?id=${id}`, {
				credentials: 'include'
			})
			.then(h => h.json())
			.then(h => {
				if (h) {
					// console.log(h)
					fetch(DB + ORGANIZATION, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.options = data
							this.selected = h[0].f_11
							EventBus.$emit(`edit_organization`, this.selected)
						}
						else {
							this.options = []
						}
					})
					.catch(err => console.log(err))
				}
			})
			.catch(err => console.log(err))
		}
		/*watch: {
			org_id(id) {
				if (typeof id !== 'undefined') {
					fetch(DB + ORGANIZATION, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.options = [{id: '0', name: ''}, ...data]; 
							this.selected = id
						}
						else {
							this.options = []
						}
					})
					.catch(err => console.log(err))
				}
			}
		}*/
	}
</script>


// WEBPACK FOOTER //
// organization.vue?d7d63418